import * as React from 'react';
import * as ReactMarkdown from 'react-markdown';
export default function Cta({ text, primaryCta, secondaryCta, primaryHref, secondaryHref }) {
    return (React.createElement("div", { className: "mw7 center ph3 ph5-ns tc br2 pv4 pv5-l bg-washed-yellow dark-gray mt4 mb5" },
        React.createElement(ReactMarkdown, { source: text, className: "content" }),
        React.createElement("div", { className: "flex flex-wrap items-center justify-center" },
            React.createElement("a", { href: primaryHref, className: "" },
                React.createElement("span", { className: "b f6 f5-ns br2 bg-yellow near-black no-underline grow pv2 ph3 dib mr3" }, primaryCta)),
            React.createElement("a", { href: secondaryHref, className: "" },
                React.createElement("span", { className: "b f6 f5-ns br2 bg-gray white no-underline grow pv2 ph3 dib" }, secondaryCta)))));
}
//# sourceMappingURL=Cta.js.map